export const isActiveMembership = (user: any): boolean => {
    if (user.role === 1) return true;

    return user.subscription_active && new Date(user.subscription_expiry) > new Date();
}; 